export default __webpack_public_path__ + "img/bc52678d98d4847f08d5e02b4b3f67fa.svg";